import { ICompany } from '@nxsys/types/models/company';
import ZohoSettingsForm from './components/ZohoSettingsForm';

type Props = {
  data?: ICompany;
  companyId?: string;
};

const ZohoSettingsTab: React.FC<Props> = ({ data }) => {
  return (
    <div>
      {data && <ZohoSettingsForm companyData={data} />}
    </div>
  );
};

export default ZohoSettingsTab;
